module.exports = __webpack_public_path__ + "img/treatments-3.6d15c47a.png";